// extracted by mini-css-extract-plugin
export default {"badge":"DiscountBadge_badge__ngAgk","show":"DiscountBadge_show__Xhf8C","discount":"DiscountBadge_discount__13MT8","icon":"DiscountBadge_icon__er9F3"};